module.exports = __webpack_public_path__ + "static/media/Articles_of_Incorporation_signed.980029af.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Articles_of_Incorporation_signed.pdf
// module id = 90
// module chunks = 0